<pdf-shy-button
  title="Document Properties…"
  primaryToolbarId="documentProperties"
  [cssClass]="show() | responsiveCSSClass : 'always-in-secondary-menu'"
  l10nId="pdfjs-document-properties-button"
  l10nLabel="pdfjs-document-properties-button-label"
  [order]="5000"
  eventBusName="documentproperties"
  [closeOnClick]="true"
  [disabled]="disable()"
  image="<svg aria-hidden='true' focusable='false' width='20px' height='20px' viewBox='-1 0 17 16'><path fill='currentColor' d='M8 16a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM8 2a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6z' /><path fill='currentColor' d='M8 7a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z' /><circle fill='currentColor' cx='8' cy='5' r='1.188' /></svg>"
>
</pdf-shy-button>
